package com.devi3east.bashbuddy.prizeList.domain.models

import kotlinx.serialization.Serializable

@Serializable
enum class PrizeType {
    MAIN_EVENT,
    SIDE_RAFFLE
}